import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '../main/main.component';
import { RecipesComponent } from './pages/recipes.component';
import { RecipeDetailComponent } from './content/recipe-detail/recipe-detail.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'recetas',
        component: RecipesComponent
      },
      {
        path: 'receta-detalle/:id',
        component: RecipeDetailComponent
      }
    ]
  },
];

export const RecipesRoutes = RouterModule.forChild(routes);
